import axios from "axios";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { setSessionData } from "./sessionSlice";

import "react-datepicker/dist/react-datepicker.css";
import "./App.css";
import "./assets/css/main/main.css";
import { RoutesData } from "./data/arrays/routes";
import AsideBar from "./layout/AsideBar/AsideBar";
import { ToggleProvider } from "./layout/ToggleContext";
import CopyRight from "./layout/footer/CopyRight";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./styles/MUI/GlobalTheme";
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import TermsAndConditions from "./pages/Legal/TermsAndConditions";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    axios
      .get("/getsession")
      .then((response) => {
        // debugger
     
        dispatch(setSessionData(response?.data));
      })
      .catch((error) => {
        console.error("Error fetching navigation content:", error);
      });
  }, []);

  return (
    // <DynamicMenuProvider>
    <ToggleProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        {/* Wrapper for all other routes */}
        <Route element={<MainLayout />}>
          {/* Map RoutesData to Route components */}
          {RoutesData.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Route>
      </Routes>
    </Router>
    </ThemeProvider>
    </ToggleProvider>
    // </DynamicMenuProvider>

  );
}

const MainLayout = () => (
  <div className="reactBody m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--fixed m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default">
    <div className="m-grid m-grid--hor m-grid--root m-page">
      <AsideBar />
      <div className="mainWrap">
        <Outlet />
      </div>
      {/* <CopyRight/> */}
    </div>
  </div>
);

export default App;


 
